import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../../../constants/colors'

export interface EmptySlotPlaceholderProps {
  /** Whether the team needs more people (show red state) */
  needsAttention?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * EmptySlotPlaceholder Component
 * Shows empty participant slots in teams
 * Displays in red when the team needs more people to meet minimum requirements
 */
export const EmptySlotPlaceholder: React.FC<EmptySlotPlaceholderProps> = ({
  needsAttention = false,
  className = ''
}) => {
  // Debug logging

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        border: 2,
        borderStyle: 'dashed',
        borderColor: needsAttention ? INTERAX_COLORS.redError : INTERAX_COLORS.heritageBlue,
        minHeight: '60px',
        backgroundColor: needsAttention ? INTERAX_COLORS.redErrorBackground : 'transparent',
        background: needsAttention
          ? INTERAX_COLORS.redErrorBackground
          : 'radial-gradient(circle at center, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 60%), rgba(46, 79, 95, 0.3)',
        transition: 'all 0.2s'
      }}
    />
  )
}
